module.exports = __webpack_public_path__ + "static/media/ic_news.91da6053.svg";